export enum EloquaInputTypeEnum {
  TEXT = 'text',
  EMAIL = 'email',
  CHECKBOX = 'checkbox',
  SELECT = 'select',
  SUBMIT = 'submit',
}
